import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InputBoolean } from 'ng-zorro-antd';
import { ButtonSize, ButtonType } from './hd-button.service';
@Component({
  selector: 'hd-button',
  templateUrl: './hd-button.component.html',
  styleUrls: ['./hd-button.component.less']
})
export class HdButtonComponent implements OnInit {

  // 默认default
  @Input() type: ButtonType = ButtonType.default;
  @Input() size: ButtonSize = ButtonSize.normal;
  @Input() @InputBoolean() loading: boolean;
  @Input() @InputBoolean() disabled: boolean = false;
  @Output() clickAction = new EventEmitter<any>();
  @Output() nzOnConfirm = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
    if ((this.loading === false || this.loading === true) && this.clickAction.observers.length === 0 && this.nzOnConfirm.observers.length === 0) {
      throw '存在loading效果的hd-button组件禁止使用click绑定点击事件，请使用clickAction绑定!';
    }
    if (this.type === 'submit') {
      throw '禁止使用submit类型的按钮，请使用普通按钮+click事件触发表单提交!';
    }
  }

  /** loading 时一并禁用，避免与外部 [disabled] 绑定互相翻转状态 */
  get isDisabled(): boolean {
    return this.disabled || this.loading;
  }

  innerClickAction(option: any) {
    // loading 状态下，不允许触发点击事件
    if (this.loading) {
      return;
    }
    this.clickAction.emit(option);
  }
}
